import React from 'react';
import { useSelector } from 'react-redux';

import AboutBreedModule from 'dpl/components/BreederProfile/Show/AboutBreedModule';
import ExploreBreedByStateModule from 'dpl/components/BreederProfile/Show/ExploreBreedByStateModule';
import GoodDogValueBanner from 'dpl/components/BreederProfile/Show/GoodDogValueBanner';
import ReservedAndPastPuppiesList from 'dpl/components/BreederProfile/mobile/components/overview/ReservedAndPastPuppiesList';
import Divider from 'dpl/components/BreederProfile/mobile/components/shared/Divider';

import BreederProfileAdoptionProcessSectionContainer from '../BreederProfileAdoptionProcessSectionContainer';
import BreederProfileCurrentPuppiesSectionContainer from '../BreederProfileCurrentPuppiesSectionContainer';
import BreederProfileDeliverySectionContainer from '../BreederProfileDeliverySectionContainer';
import BreederProfileHealthTestsSectionContainer from '../BreederProfileHealthTestsSectionContainer';
import BreederProfileLittersSectionContainer from '../BreederProfileLittersSectionContainer';
import BreederProfileMainContainer from '../BreederProfileMainContainer';
import BreederProfileMeetBreederSectionContainer from '../BreederProfileMeetBreederSectionContainer';
import BreederProfileMoreAboutBreederSectionContainer from '../BreederProfileMoreAboutBreederSectionContainer';
import BreederProfileOwnerStoriesContainer from '../BreederProfileOwnerStoriesContainer';
import BreederProfileParentsSectionContainer from '../BreederProfileParentsSectionContainer';
import BreederProfilePhotosSectionContainer from '../BreederProfilePhotosSectionContainer';
import BreederProfileRelatedBreedsContainer from '../BreederProfileRelatedBreedsContainer';
import BreederProfileUpdatesSectionContainer from '../BreederProfileUpdatesSectionContainer';

export default function BreederProfileOverviewTabContainer() {
  const { isSearchEngineReferral, hasBreederPosts, hasCurrentLitters } =
    useSelector(({ server }) => server);

  return (
    <div className="BreederProfileOverviewTabContainer">
      <BreederProfileMainContainer />
      {isSearchEngineReferral ? (
        <>
          <BreederProfileMeetBreederSectionContainer />
          <BreederProfileCurrentPuppiesSectionContainer />
          <BreederProfileLittersSectionContainer />
        </>
      ) : (
        <>
          <BreederProfileCurrentPuppiesSectionContainer />
          <BreederProfileLittersSectionContainer />
          {hasCurrentLitters && <Divider className="hidden md:block" />}
          <BreederProfileMeetBreederSectionContainer />
        </>
      )}
      <ReservedAndPastPuppiesList />
      {isSearchEngineReferral && <GoodDogValueBanner />}
      <BreederProfileAdoptionProcessSectionContainer />
      <BreederProfileDeliverySectionContainer />
      <Divider className="hidden md:block" />
      <BreederProfileMoreAboutBreederSectionContainer />
      {hasBreederPosts && <Divider className="hidden md:block" />}
      <BreederProfileUpdatesSectionContainer />
      <BreederProfileParentsSectionContainer />
      <BreederProfileHealthTestsSectionContainer />
      <BreederProfileOwnerStoriesContainer />
      <BreederProfilePhotosSectionContainer />
      {isSearchEngineReferral && (
        <>
          <AboutBreedModule />
          <ExploreBreedByStateModule />
        </>
      )}
      <BreederProfileRelatedBreedsContainer />
    </div>
  );
}
